import { Paper, BottomNavigation as MuiBottomNavigation, BottomNavigationAction } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import HistoryIcon from '@mui/icons-material/History';
import ViewListIcon from '@mui/icons-material/ViewList';
import SettingsIcon from '@mui/icons-material/Settings';

export default function BottomNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const getValue = () => {
    switch (location.pathname) {
      case '/':
        return 0;
      case '/history':
        return 1;
      case '/templates':
        return 2;
      case '/settings':
        return 3;
      default:
        return 0;
    }
  };

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        borderTop: 1,
        borderColor: 'divider'
      }} 
      elevation={3}
    >
      <MuiBottomNavigation
        showLabels
        value={getValue()}
        onChange={(_event: React.SyntheticEvent, newValue: number) => {
          switch (newValue) {
            case 0:
              navigate('/');
              break;
            case 1:
              navigate('/history');
              break;
            case 2:
              navigate('/templates');
              break;
            case 3:
              navigate('/settings');
              break;
          }
        }}
      >
        <BottomNavigationAction 
          label="Main" 
          icon={<HomeIcon />} 
        />
        <BottomNavigationAction 
          label="History" 
          icon={<HistoryIcon />} 
        />
        <BottomNavigationAction 
          label="Templates" 
          icon={<ViewListIcon />} 
        />
        <BottomNavigationAction 
          label="Settings" 
          icon={<SettingsIcon />} 
        />
      </MuiBottomNavigation>
    </Paper>
  );
} 